<style scoped>
.validValueCss {
  display: inline-block;
  font-family: SimSun;
  font-size: 12px;
  color: #ed3f14;
  position: relative;
  top:0px;
  left: 5px;
}
</style>
<template>
  <div>
      <!--返回列表按钮-->
      <div style="margin:0 0 10px 10px;">
        <Icon type="chevron-left"></Icon>
        <a @click='backPage'>{{ $t('common.backToList') }}</a>
      </div>
      <div style="background-color: #fff;margin:0 10px 0 10px;padding:10px 0 0 10px;">
        <Form ref="pageParams" :model="pageParams" :label-width="180" label-position="right" :rules="ruleValidate">
            <span style="color:#ed3f14;font-size:10px;">({{$t('logisticsProvider.remark')}})</span>
            <h2>{{$t('logisticsProvider.baseInformation')}}</h2>
            <div style="padding-left:20px;padding-top:10px;">
              <Row>
                <!-- 渠道名称 -->
                <Col span="10">
                  <Form-item :label="$t('logisticsProvider.channelName') + '：'" prop="shippingMethodName">
                    <Input v-model.trim="pageParams.shippingMethodName"></Input>
                  </Form-item>
                </Col>
                <!-- 渠道代码 -->
                <Col span="10" push="2">
                  <Form-item :label="$t('logisticsProvider.channelNum') + '：'" prop="shippingMethodCode">
                    <Input v-model.trim="pageParams.shippingMethodCode"></Input>
                  </Form-item>
                </Col>
              </Row>
              <Row>
                <Col span="12">
                  <!-- 是否有跟踪号 -->
                  <Form-item :label="$t('common.haveTrackNum') + '：'" prop="hasTrackingNumber">
                    <RadioGroup v-model="pageParams.hasTrackingNumber">
                      <Radio :label="1">{{ $t('common.yes') }}</Radio>
                      <Radio :label="0">{{ $t('common.not') }}</Radio>
                    </RadioGroup>
                  </Form-item>
                </Col>
                <Col span="10">
                  <!-- 是否需要交运 -->
                  <Form-item :label="$t('common.confirmRequired') + '：'" prop="confirmRequired">
                    <RadioGroup v-model="pageParams.confirmRequired">
                      <Radio :label="1">{{ $t('common.yes') }}</Radio>
                      <Radio :label="0">{{ $t('common.not') }}</Radio>
                    </RadioGroup>
                  </Form-item>
                </Col>
              </Row>
              <Row>
                <Col span="12">
                  <!-- 追踪信息查询网址 -->
                  <Form-item :label="$t('common.trackUrl') + '：'" prop="trackUrl">
                    <Input v-model.trim="pageParams.trackUrl"></Input>
                  </Form-item>
                </Col>
                <Col span="10">

                </Col>
              </Row>
          </div>
          <div class="cutline"></div>
          <!-- 动态参数 -->
          <div class="canalInfo" v-if="dyParams.length">
            <h2>{{$t('common.dyParams')}}</h2>
            <div class="explain" style="padding-left: 20px;">
              <div class="paramsCont" v-for="(item, index) in dyParams" :key="index">
                <Form-item v-if="item.parameterType !== '05' && item.parameterType !== '06'" :label="item.parameterName + '：'">
                  <!-- 01:radio -->
                  <RadioGroup v-model="dyParams[index].paramValue1" style="display:inline-block;marginLeft:3px;" v-if="item.parameterType === '01'">
                    <Radio v-for="(n, i) in item.optionList" :key="i" :label="n.parameterValue">{{n.parameterValDesc}}</Radio>
                  </RadioGroup>
                  <!-- 02:checkbox -->
                  <CheckboxGroup v-model="dyParams[index].paramValue2" style="display:inline-block;marginLeft:3px;" v-if="item.parameterType === '02'">
                    <Checkbox v-for="(n, i) in item.optionList" :key="i" :label="n.parameterValue">{{n.parameterValDesc}}</Checkbox>
                  </CheckboxGroup>
                  <!-- 03:input -->
                  <Input v-if="item.parameterType === '03'" v-model.trim="dyParams[index].paramValue3" style="width:300px;"></Input>
                  <!-- 04:select -->
                  <!-- <select v-if="item.parameterType === '04'" v-model="dyParams[index].paramValue4" style="display:inline-block;marginLeft:3px;border: 1px solid #cccccc;height:28px;width:120px;">
                      <option :value="n.parameterValue" v-for="(n, i) in item.optionList" :key="i">{{n.parameterValueDesc}}</option>
                  </select> -->
                  <Select v-if="item.parameterType === '04'" v-model="dyParams[index].paramValue4" style="width:180px;">
                    <Option v-for="(n, i) in item.optionList" :value="n.parameterValue" :key="i">{{n.parameterValueDesc}}</Option>
                  </Select>
                  <!-- 05:hidden -->
                  <!-- 06-readonly -->
                </Form-item>
              </div>
            </div>
          </div>
          <div class="cutline"></div>
        </Form>
        <div class='fr' style="margin:20px 0;">
          <Button @click="cancel" style="margin-right:10px;" icon="close-round">{{$t('common.cancel')}}</Button>
          <Button type="primary" @click="saveBtn" :loading="loading2" icon="checkmark-round">{{$t('common.save')}}</Button>
        </div>
      </div>
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
export default {
  props: ['shippingId', 'addFlag', 'carrierId', 'warehouseId'],
  mixins: [ Mixin, tableMixin ],
  components: {

  },
  data () {
    let self = this;
    return {
      loading2: false,
      shipId: null, // 渠道ID
      pageParams: {
        shippingMethodName: '', // 渠道名称
        shippingMethodCode: '', // 渠道代码
        hasTrackingNumber: '', // 是否有跟踪号
        confirmRequired: '', // 是否需要交运
        trackUrl: '', // 追踪信息查询网址
        defParamList: [] // 保存的动态参数
      },
      // 校验
      ruleValidate: {
        shippingMethodName: [
          { required: true, message: self.t('validValue.noshipMethodName'), trigger: 'blur' }
        ],
        shippingMethodCode: [
          { required: true, message: self.t('validValue.noshipMethodCode'), trigger: 'blur' }
        ],
        hasTrackingNumber: [
          { required: true, message: self.t('validValue.noHasTrackingNumber'), trigger: 'blur' }
        ]
      },
      dyParams: [], // 动态参数
      selectedDataList: []// 已选择的动态参数列表
    };
  },
  methods: {
    // 返回列表
    backPage () {
      this.$parent.workShow = 'list';
    },
    // 保存渠道信息校验
    saveValidFn () {
      let v = this;
      let valid = true;
      // var reg = /^\d+$/;
      // 渠道名称
      if (v.pageParams.shippingMethodName === '') {
        v.$Message.info({
          content: v.t('validValue.noshipMethodName'),
          duration: 3
        });
        valid = false;
        return;
      }
      // 渠道代码
      var re = /[\u4e00-\u9fa5]/;
      let value = v.pageParams.shippingMethodCode;
      if (re.test(value) && value !== '') {
        // v.$Message.info({
        //   content: v.t('validValue.chMethodCode'),
        //   duration: 3
        // });
        // valid = false;
        // return;
      } else if (value === '') {
        v.$Message.info({
          content: v.t('validValue.noshipMethodCode'),
          duration: 3
        });
        valid = false;
        return;
      }
      // 是否有跟踪号
      let receiveTrackList = v.pageParams.hasTrackingNumber;
      if (receiveTrackList.length === 0) {
        v.$Message.info({
          content: v.t('validValue.noHasTrackingNumber'),
          duration: 3
        });
        valid = false;
        return;
      }
      // 追踪信息查询网址
      //   var regUrl = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
      //   let urlVal = v.pageParams.trackUrl;
      //   if (!regUrl.test(urlVal) && urlVal !== '' && urlVal !== null) {
      //     v.$Message.info({
      //       content: v.t('validValue.trackUrlError'),
      //       duration: 3
      //     });
      //     valid = false;
      //     return;
      //   }
      return valid;
    },
    // 查询渠道详情
    getCanalDtlInfo () {
      let v = this;
      v.axios.post(api.warehouse_queryOwarehouseDetail + '?shippingMethodId=' + v.shippingId)
        .then(res => {
          if (res.data.code === 0) {
            let data = res.data.datas;
            v.pageParams.shippingMethodName = data.shippingMethodName; // 渠道名称
            v.pageParams.shippingMethodCode = data.shippingMethodCode; // 渠道代码
            v.pageParams.hasTrackingNumber = data.hasTrackingNumber; // 是否有跟踪号
            v.pageParams.confirmRequired = data.confirmRequired; // 是否需要交运
            v.pageParams.trackUrl = data.trackUrl; // 追踪信息查询网址
            v.pageParams.defParamList = data.defParamList; // 保存的动态参数
            v.selectedDataList = data.defParamList; // 选中的动态参数
            v.initSelectParamsFn();
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 获取动态参数
    getParams () {
      let v = this;
      let pos = [];
      v.axios.post(api.get_params2ver)
        .then(res => {
          if (res.data.code === 0) {
            let data = res.data.datas;
            if (data) {
              data.forEach((n, i) => {
                pos.push({
                  parameterName: n.parameterName,
                  parameterType: n.parameterType,
                  parameterKey: n.parameterKey,
                  optionList: n.optionList
                });
              });
              v.dyParams = pos;
            }
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 显示选中的动态参数
    initSelectParamsFn () {
      let v = this;
      for (let i = 0; i < v.dyParams.length; i++) {
        let out = v.dyParams[i]; // 外层
        if (v.dyParams[i].optionList != null) {
          for (let t = 0; t < v.dyParams[i].optionList.length; t++) {
            for (let j = 0; j < v.selectedDataList.length; j++) {
              let a = v.selectedDataList[j]; // 外层
              if (out.parameterType === '01' && out.parameterKey === a.parameterKey) {
                out.paramValue1 = a.parameterValue;
              } else if (out.parameterType === '02') {
                out.paramValue2 = a.parameterValue.split(',');
              } else if (out.parameterType === '04' && out.parameterKey === a.parameterKey) {
                out.paramValue4 = a.parameterValue;
              }
            }
          }
        } else if (out.parameterType === '03') {
          for (let j = 0; j < v.selectedDataList.length; j++) {
            let a = v.selectedDataList[j]; // 外层
            if (out.parameterKey === a.parameterKey) {
              out.paramValue3 = a.parameterValue;
            }
          }
        }
      }
    },
    // 保存渠道
    saveBtn () {
      let v = this;
      let pos = [];
      v.loading2 = true; // 保存加载
      // 组装参数
      // 动态参数
      for (let i = 0; i < v.dyParams.length; i++) {
        let out = v.dyParams[i];
        if (v.dyParams[i].optionList != null) { // 有选项
          for (let t = 0; t < v.dyParams[i].optionList.length; t++) {
            let lining = v.dyParams[i].optionList[t];
            if (out.parameterType === '01') {
              if (out.paramValue1 === lining.parameterValue) {
                pos.push({
                  parameterValue: out.paramValue1,
                  parameterDesc: out.parameterName,
                  parameterKey: out.parameterKey
                });
              }
            } else if (out.parameterType === '02') {
              let parameterValue = '';
              for (let n = 0; n < out.paramValue2.length; n++) {
                if (out.paramValue2[n] === lining.parameterValue) {
                  if (parameterValue !== '') {
                    parameterValue += ',';
                  }
                  parameterValue += lining.parameterValue;
                }
              }
              if (parameterValue !== '') {
                pos.push({
                  parameterValue: parameterValue,
                  parameterDesc: out.parameterName,
                  parameterKey: out.parameterKey
                });
              }
            } else if (out.parameterType === '04') {
              if (out.paramValue4 === lining.parameterValue) {
                pos.push({
                  parameterValue: out.paramValue4,
                  parameterDesc: out.parameterName,
                  parameterKey: out.parameterKey
                });
              }
            }
          }
        } else if (out.parameterType === '03') { // 没有选项
          if (out.paramValue3 != null && out.paramValue3 !== '') {
            pos.push({
              parameterValue: out.paramValue3,
              parameterDesc: out.parameterName,
              parameterKey: out.parameterKey
            });
          }
        }
      }
      let objParams = {
        warehouseId: v.warehouseId,
        carrierId: v.carrierId,
        shippingMethodId: v.shippingId, // 渠道ID
        shippingMethodName: v.pageParams.shippingMethodName, // 渠道名称
        shippingMethodCode: v.pageParams.shippingMethodCode, // 渠道代码
        hasTrackingNumber: v.pageParams.hasTrackingNumber, // 是否有跟踪号
        confirmRequired: v.pageParams.confirmRequired, // 是否需要交运
        trackUrl: v.pageParams.trackUrl, // 追踪信息查询网址
        defParamList: pos // 保存的动态参数
      };
      if (v.saveValidFn()) {
        v.axios.post(api.warehouse_saveOwarehosue, objParams)
          .then(res => {
            if (res.data.code === 0) {
              v.loading2 = false; // 保存加载
              v.$Message.success(v.t('common.saveSuccess'));
              v.$parent.workShow = 'list'; // 新增成功之后，关闭模态框
              v.clearFormData();
              v.$parent.pageParamsStatus = true; // 保存成功之后，触发表格刷新
            } else {
              v.loading2 = false; // 保存加载
              v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
            }
          });
      } else {
        v.loading2 = false; // 保存加载
      }
    },
    // 取消新增
    cancel () {
      let v = this;
      if (v.addFlag === 'add') {
        v.$parent.workShow = 'list'; // 关闭模态框
        v.clearFormData();
      } else {
        v.$parent.workShow = 'list'; // 关闭模态框
      }
    },
    // 清空表单数据
    clearFormData () {
      let v = this;
      v.pageParams.shippingMethodName = ''; // 渠道名称
      v.pageParams.shippingMethodCode = ''; // 渠道代码
      v.pageParams.hasTrackingNumber = ''; // 是否有跟踪号
      v.pageParams.confirmRequired = ''; // 是否需要交运
      v.pageParams.trackUrl = ''; // 追踪信息查询网址
    }
  },
  created () {
    let v = this;
    v.getParams(); // 动态参数
    if (v.shippingId) {
      v.shipId = v.shippingId; // 渠道ID
      setTimeout(function () {
        v.getCanalDtlInfo(); // 查询渠道信息
      }, 100);
    } else {
      v.shipId = null;
    }
  },
  watch: {
    addFlag: function (val) {
      if (val === 'add') {
        this.clearFormData();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/logisticsProvider/components/logisticsProvider/owChannelManagementDetail.vue